import { useState } from "react"
import { NotificationIcons, MyToolIcons, ReferUserIcons, RenewIcons, BulletinIcon, PublicationIcon, SaveIcon } from '../../global/Icons';

export const NavigationStates = () => {
    const [tabs, setTabs] = useState({
        top: [
            {name:'Notifications', className:'', subdir:'/notification', ref: '/psl/notification', not_active: <NotificationIcons fill="#333333" />, active: <NotificationIcons  fill="#3D77E9" />},
            {name:'MyTools', className:'tenth-step', subdir:'#', ref: '__mytools', not_active:<MyToolIcons fill="#292D32" />, active:<MyToolIcons fill="#3D77E9" stroke="#3D77E9" />},
        ],
        mtop: [
            {name:'Notifications', className:'', subdir:'/notification', ref: '/notification', not_active: <NotificationIcons fill="#fff" />, active: <NotificationIcons fill="#3D77E9" />},
            {name:'MyTools', className:'tenth-step', subdir:'#', ref: '__mytools', not_active:<MyToolIcons fill="#FFFFFF" stroke="#FFFFFF" />, active:<MyToolIcons fill="#3D77E9" stroke="#3D77E9"/>},
        ],
        left: [
            {name:'Publication', sub_name:'', subdir:'/psl/publication?tab=article', ref: 'publication', steps:'', not_active:<PublicationIcon type="not_active" />, active:<PublicationIcon type="active" />},
            {name:'Bulletin', sub_name:'', subdir:'/psl/bulletin', ref: 'bulletin', steps:'', not_active:<BulletinIcon type="not_active" />, active:<BulletinIcon type="active" />},
            {name:'Save', sub_name:'', subdir:'/psl/save', ref: 'save', steps:'', not_active:<SaveIcon height="25px" width="24px" type="not_active" />, active:<SaveIcon height="25px" width="24px" type="active" />},
        ],
        msetting: [
            {name:'Refer a Hero Users', subdir:'/psl', ref: 'psl', steps: 'sixth-step', not_active:<ReferUserIcons fill="#fff" stroke="#A2A3A9"/>, active:<ReferUserIcons fill="#333333" stroke="#333333"/>},
            {name:'System Updates', subdir:'/psl', ref: 'psl', steps: 'seventh-step', not_active:<RenewIcons fill="none" stroke="#89A594"/>, active:<RenewIcons fill="#333333" stroke="#333333"/>},
        ],
        mobile: [
            {name:'Publication', sub_name:'', subdir:'/psl/publication?tab=article', ref: 'publication', steps:'', not_active:<PublicationIcon type="not_active" />, active:<PublicationIcon type="active" />},
            {name:'Bulletin', sub_name:'', subdir:'/psl/bulletin', ref: 'bulletin', steps:'', not_active:<BulletinIcon type="not_active" />, active:<BulletinIcon type="active" />},
            {name:'Save', sub_name:'', subdir:'/psl/save', ref: 'save', steps:'', not_active:<SaveIcon height="25px" width="24px" type="not_active" />, active:<SaveIcon height="25px" width="24px" type="active" />},
        ]
    })
    const [tc, setTc] = useState({open: true, list: false})
    const [leftBar, setLeftbar] = useState(true)
    const [openNotif,  setOpenNotif] = useState(false)
    const [myTool, setMyTool] = useState(false)

    return {
        tabs: {data: tabs, set: setTabs},
        tc: {data: tc, set: setTc},
        leftBar: {data: leftBar, set: setLeftbar},
        openNotif: {data: openNotif, set: setOpenNotif},
        myTool: {data: myTool, set: setMyTool},
    }
}